"use client";

import { useEffect, useState } from "react";

// eslint-disable-next-line turbo/no-undeclared-env-vars
const vercelCommitHash = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA;
const commitHash = vercelCommitHash ? `-${vercelCommitHash.slice(0, 7)}` : "";
const spriteUrl = `${process.env.NEXT_PUBLIC_WEBAPP_URL}/icons/sprite.svg?v=${process.env.NEXT_PUBLIC_CALCOM_VERSION}-${commitHash}`;

// Direct fetch + inline injection instead of react-inlinesvg: the icon
// system (Icon.tsx's <use href="#name">) depends entirely on this sprite's
// <symbol> defs existing in the DOM, and react-inlinesvg was silently
// failing to inject them (fetch never completing / component never
// mounting content — no visible error, just every icon rendering as an
// empty <use> pointing at nothing). This is deliberately minimal: one
// fetch, one dangerouslySetInnerHTML, no library layer that can silently
// no-op. See BUILD-LOG.md.
export function IconSprites() {
  const [svgMarkup, setSvgMarkup] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetch(spriteUrl)
      .then((res) => (res.ok ? res.text() : Promise.reject(new Error(`sprite fetch failed: ${res.status}`))))
      .then((text) => {
        if (!cancelled) setSvgMarkup(text);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error("Failed to load icon sprite", err);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!svgMarkup) return null;

  // eslint-disable-next-line react/no-danger
  return <div style={{ display: "none" }} dangerouslySetInnerHTML={{ __html: svgMarkup }} />;
}

export default IconSprites;
